import { Component, OnInit } from '@angular/core';
import {FormGroup, FormBuilder} from "@angular/forms";
import {AuthenticationService} from "../shared/services/authentication/authentication.service";
import {Router} from "@angular/router";
import {AuthGuardService} from "../shared/services/authentication/auth-guard.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  errorMessage: string = "";
  isLoading: boolean = false;

  constructor(private formBuilder: FormBuilder,
              private authenticationService: AuthenticationService,
              private router: Router) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      "email": [],
      "password": [],
      "remember": [true]
    })
  }

  public login() {
    this.isLoading = true;
    this.authenticationService.login(this.loginForm.value["email"], this.loginForm.value["password"], this.loginForm.value["remember"])
      .subscribe(
      response => {
        this.router.navigateByUrl(AuthGuardService.redirectUrl != null ? AuthGuardService.redirectUrl : '/');
      },
      error => {
        this.isLoading = false;
        this.errorMessage = error["error_description"];
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/login/login.component.ts